module.exports = __webpack_public_path__ + "static/img/background.e413d4ae.svg";